import { render, staticRenderFns } from "./studentSelecter.vue?vue&type=template&id=42946d3d&scoped=true"
import script from "./studentSelecter.vue?vue&type=script&lang=js"
export * from "./studentSelecter.vue?vue&type=script&lang=js"
import style0 from "./studentSelecter.vue?vue&type=style&index=0&id=42946d3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42946d3d",
  null
  
)

export default component.exports